import { render } from "./AvatarVue.vue?vue&type=template&id=b1a856f8&scoped=true"
import script from "./AvatarVue.vue?vue&type=script&lang=js"
export * from "./AvatarVue.vue?vue&type=script&lang=js"

import "./AvatarVue.vue?vue&type=style&index=0&id=b1a856f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a856f8"]])

export default __exports__